import instance from "src/axios/axios";
import { Token } from "src/models/token";
export interface User
{
  isSuccessful: boolean,
  message: string,
  token: Token,
  userId: number,
  accountType: AccountType| string,
}
export enum AccountType {
  Investor= "Investor",
  Startup= "Startup",
  Accelerator= "Accelerator",
}
export const setSession = (accessToken: string | null, refreshToken: string | null, user: User | null): void => {
  if (accessToken) {
    const localUser = window.localStorage.getItem('user');
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    window.localStorage.setItem('user', JSON.stringify(user));
    instance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // instance.defaults.headers.common.RefreshAuthorization = `Bearer ${refreshToken}`
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    delete instance.defaults.headers.common.Authorization;
    delete instance.defaults.headers.common.RefreshAuthorization;
  }
};